<section class="section overflow-hidden">
  <div class="container pt-4 bring-to-front">
    <div class="row">
      <div class="col-md-10 mx-md-auto">
        <dc-form-register-simple-inline></dc-form-register-simple-inline>
      </div>
    </div>
  </div>
</section>
